export default __webpack_public_path__ + "static/media/foresta-small.8f1e6ae1.png";